﻿/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, View } from 'react-native';
import { modalShellShared } from '../modals/modalShellShared.styles';

type Props = {
  label: string;
};

/** Badge compacto en banda hero de modales (inventario, cat├ílogo). */
export function ModalHeroBadge({ label }: Props) {
  return (
    <View style={modalShellShared.heroBadge}>
      <Text style={modalShellShared.heroBadgeText}>{label}</Text>
    </View>
  );
}
